import React from 'react';
import MaterialIcon from '../MaterialIcon';

const WhyUs = () => {
  return (
    <section className="relative py-16 md:py-24 bg-white overflow-hidden">
      {/* 动态背景元素 */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 right-0 w-[800px] h-[800px] bg-[#F1F600]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
        <div className="absolute top-1/3 left-0 w-[700px] h-[700px] bg-[#FF4D4D]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-1/4 left-1/2 w-[600px] h-[600px] bg-[#2C3E50]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative container-wide">
        <div className="text-center mb-24">
          <h2 className="text-5xl font-bold mb-6">
            <span className="relative inline-block group">
              <span className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">为什么选择我们</span>
              <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-amber-400 to-yellow-400 transform scale-x-50 group-hover:scale-x-100 transition-transform duration-500"></div>
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-medium">专业、创新、高效的一站式教练服务平台</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 max-w-[85%] mx-auto">
          {/* 猎头式教练匹配 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-amber-500 to-yellow-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-200 to-yellow-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-amber-400 to-yellow-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="handshake" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-amber-600 transition-colors duration-300">猎头式教练匹配</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                精准匹配最适合的教练，确保教练服务效果最大化
              </p>
            </div>
          </div>

          {/* 专业APP平台 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-500 to-violet-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-200 to-violet-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-purple-400 to-violet-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="smartphone" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-purple-600 transition-colors duration-300">专业APP平台</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                随时随地进行教练会谈，记录成长轨迹
              </p>
            </div>
          </div>

          {/* 企业后台 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-emerald-500 to-green-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-200 to-green-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-emerald-400 to-green-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="admin_panel_settings" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-emerald-600 transition-colors duration-300">企业后台</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                完整的企业管理系统，轻松管理教练服务
              </p>
            </div>
          </div>

          {/* 企业数据看板 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-cyan-500 to-teal-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-200 to-teal-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-cyan-400 to-teal-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="analytics" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-cyan-600 transition-colors duration-300">企业数据看板</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                实时监控服务进度，深入分析投资回报
              </p>
            </div>
          </div>

          {/* AI教练 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-pink-500 to-rose-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-pink-200 to-rose-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-pink-400 to-rose-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="psychology" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-pink-600 transition-colors duration-300">AI教练</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                智能AI教练7x24小时在线，提供即时辅导与练习
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
